<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-8 col-6">
                    <h2>Failure Logs</h2>
                    </div>
                    <div class="col-lg-4 col-6 text-right bid">
                    <!-- <button  type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSTOMER</button>
                    <button type="button" class="btn btn-info"><i class="fas fa-file"></i> IMPORT DATA</button> -->
                    <form v-if="moduleName == 'ims'" @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                        <i @click="searchLog()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchLog" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>              
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >Type</th>
                               <th 
                                    scope="col" 
                                    class="sort"
                                     >Message</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >Date</th>  
                                                 
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="logs.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in logs" :key="data.id">
                                <td>{{data.type}}</td>
                                <td><span data-toggle="tooltip" data-placement="left"  v-bind:title='data.message'>{{data.message | truncate(50, '...')}}</span></td>
                                <td>{{data.createdDate ? moment(data.createdDate).format("MMMM DD YYYY, h:mm:ss a") : ""}}</td>
                
                            </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation example" v-if="!(logs.length == 0 && currentPage === 0)">
                            <ul class="pagination justify-content-center">
                                <li class="page-item" v-bind:class="{ disabled: currentPage === 0 }">
                                    <a class="page-link cursor-pointer"   @click="previous()">
                                        <i class="fa fa-angle-left"></i>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                </li>
                                <li class="page-item active"><a class="page-link">{{currentPage+1}}</a></li>
                                <li class="page-item" v-bind:class="{ disabled: this.logs.length < this.perPage }"  >
                                    <a class="page-link cursor-pointer" @click="next()">
                                        <i class="fa fa-angle-right"></i>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <!-- Pagination-->
                        <!-- <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="filelogs(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div> -->
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
  name: "imsCusipComponent",
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 0,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "",
        sortOrder: "ASC",
        logs : [],
        moduleName : ""
     
    };
  },
  methods: {
    searchLog(){
        this.currentPage = 0;
        this.filelogs();  
    },
    downloadFile(downloadKey){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
           config.baseUrlBidSide +
            "/fileupload/get-file",{
                    "key":downloadKey
                },
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 0;
        this.filelogs();  
    },
    next(){
        if(this.logs.length === this.perPage){
            this.currentPage++;
            this.filelogs(); 
        }
        
    },
    previous(){
        if(this.currentPage > 0){
            this.currentPage--;
            this.filelogs(); 
        }
        
    },
    filelogs(){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      if(this.moduleName == 'autobidder')  this.searchValue = "AUTOBIDDER_EXPORT"
      this.$http
        .get(
          config.baseUrlAutoBidder + "/logs/failures"+
          "?offset="+this.currentPage+
          "&limit="+this.perPage+
          "&searchText="+this.searchValue,
          auth
        )
        .then((result) => {
            this.logs = result.data;
            this.loading = false;

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    }
   
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const moduleName = urlParams.get('moduleName');
    this.moduleName = moduleName;
    this.filelogs()
  }
};
</script>